/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ n: NonNullable<unknown> }} Rounds_Table_NInputs */



/**
* | output |
* | --- |
* | "Table {n}" |
*
* @param {Rounds_Table_NInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const rounds_table_n = /** @type {((inputs: Rounds_Table_NInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rounds_Table_NInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Table ${i?.n}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Mesa ${i?.n}`)
	if (locale === "pt") return /** @type {LocalizedString} */ (`Mesa ${i?.n}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Tavolo ${i?.n}`)
	return /** @type {LocalizedString} */ (`Table ${i?.n}`)
});